import Queries from './queries';
import Mutations from './mutations';

export default {
    Queries,
    Mutations
}